import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { StandardDialog } from '@roc/ui';
import { PricingEconomicsStepper } from './pricingEconomicsStepper';
import { CompanyProfileStore } from '../../stores/companyProfileStore';
import TermTierSelection from './termTierSelection';
import { SearchBorrowersForPricingEconomicsTier } from './searchBorrowersForPricingEconomicsTier';
import PricingEconomicsDefaultFees from './pricingEconomicsDefaultFees';

export type AddPricingEconomicsTierDialogProps = {
  open: boolean;
  handleClose: () => void;
  title: string;
  companyProfileStore: CompanyProfileStore
};

export const EditPricingEconomicTierDialog = observer((props: AddPricingEconomicsTierDialogProps) => {
  const { open, handleClose, title, companyProfileStore } = props;
  const { lenderTermTierEconomicsFormStore } = companyProfileStore

  const stepsLabels = ['Rename Term Tier', 'Defaults Fees']
  const stepsContent = [<TermTierSelection defaultNewEconomicTier={true} showRadioField={false} companyProfileStore={companyProfileStore} />, <PricingEconomicsDefaultFees companyProfileStore={companyProfileStore} />]

  const onSave = () => {
    lenderTermTierEconomicsFormStore.updateTermTierValues()
    if (lenderTermTierEconomicsFormStore.form.meta.isValid) {
      handleClose()
    }
  }

  return (
    <StandardDialog
      maxWidth={'md'}
      open={open}
      title={title}
      handleClose={handleClose}
      dialogContent={
        <>
          <PricingEconomicsStepper onSave={onSave} stepsLabel={stepsLabels} stepsContent={stepsContent} companyProfileStore={companyProfileStore} />
        </>
      }
    />
  );
});

export default EditPricingEconomicTierDialog;
